// extracted by mini-css-extract-plugin
export default {"container":"Payment_container__DY9D2","payment_title":"Payment_payment_title__75PzT","text":"Payment_text__KjAve"};